import React from 'react';
import CurrentAccountStatement from '../pages/CurrentAccountStatement';

export const currentAccountStatementRoutePage = {
  component: <CurrentAccountStatement />,
  route: '/extrato-de-conta-corrente',
};
